





























































import { plainToInstance } from "class-transformer";
import { cloneDeep } from "lodash";
import { Component, Mixins } from 'vue-property-decorator';

import HelpMessage from "../../../../../components/HelpMessage/HelpMessage.vue";
import Icon from '../../../../../components/Icon/Icon.vue';
import { ActionExecuteTypeEnum } from '../../types';
import PostActionDelayPreview from '../components/PostActionDelay/PostActionDelayPreview.vue';
import SelectPostActionItem from "../components/SelectPostActionItem.vue";
import SelectPostActionMixin from '../mixins/SelectPostActionMixin';
import { PostAction } from './PostAction';
import SelectPostActionModal from './SelectPostActionModal.vue';

@Component({
  data() {
    return {
      PostAction,
      ActionExecuteTypeEnum
    }
  },
  methods: {
    cloneDeep
  },
  components: {
    SelectPostActionItem,
    PostActionDelayPreview,
    SelectPostActionModal,
    Icon,
    HelpMessage
  }
})
export default class SelectPostAction extends Mixins<SelectPostActionMixin<PostAction>>(SelectPostActionMixin) {
  rawActionsToInstance(actions: Array<any>): Array<PostAction> {
    return plainToInstance(PostAction, actions)
  }

  hasSerialFromIndex(index: number) {
    if (this.localActions) {
      return !this.localActions.slice(index + 1).find(a => a.value.execute_type === ActionExecuteTypeEnum.Serial)
    }

    return false
  }

  get firstSerialAction() {
    if (this.localActions) {
      return this.localActions.find(a => a.value.execute_type === ActionExecuteTypeEnum.Serial) ?? null
    }

    return null
  }

  // hasSerialToIndex(index: number) {
  //   return !this.localActions?.slice(0, index).find(a => a.value.execute_type === ActionExecuteTypeEnum.Serial)
  // }
}
